import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Project from "../../models/Project";
import PageNotFound from "../../PageNotFound";

/**
 * Redirects to the first project's story engine
 * If user is on legacy plan or no projects are found, show Page not Found
 */
export default function StoryEngineRedirect({ user, subscription }) {
  const history = useHistory();
  const message = subscription.hasAccessToStoryEngine ? "Project not found." : "This page does not exist.";
  // could also have more specific message about legacy plans and SE access
  let showNotFound = useRef(null);

  useEffect(() => {
    Project.list({
      userId: user.uid,
      callback: (projects) => {
        const id = projects[0]?.id;

        // don't allow legacy plans to access SE
        if (id && subscription.hasAccessToStoryEngine) {
          history.push(`/app/project/${id}/story-engine`);
        } else {
          showNotFound.current = <PageNotFound message={message}></PageNotFound>;
          // or, if we don't want to show an error message:
          // history.push(`/app`);
        }
      },
    });
  }, []);

  return showNotFound.current;
}
